import { Plane } from "lucide-react";
import {
  DocRow, GeneratingOverlay, EmptyState, SavingBanner,
  GenerateButton, FreshnessNote,
} from "./shared";
import s from "./documents.module.css";

/**
 * Vouchers panel — flight, hotel & transfer vouchers (document_type VOUCHER).
 * Generation is wired to the live `generateVouchersFromBooking` endpoint, which
 * always regenerates in place (force) so "Regenerate" rebuilds every voucher
 * from the latest booking data and replaces the stored PDFs.
 */
const VouchersPanel = ({
  docs, generating, onGenerate, onDownload, onView, onSend, downloading, newDocIds,
  lastGeneratedAt, isStale,
}) => {
  const hasPendingSave = docs.some((d) => !d.pdfUrl && !d.pdfStuck);

  return (
    <div>
      <div className={s.panelHead}>
        <div>
          <div className={s.panelTitle}><Plane size={16} /> Vouchers</div>
          <div className={s.panelSubtitle}>
            {docs.length} voucher{docs.length !== 1 ? "s" : ""} · flight, hotel &amp; transfer
          </div>
        </div>
        <div className={s.panelActions}>
          <GenerateButton count={docs.length} generating={generating} onClick={onGenerate} noun="Vouchers" disabled={hasPendingSave} />
        </div>
      </div>

      {docs.length > 0 && (
        <FreshnessNote
          lastGeneratedAt={lastGeneratedAt}
          isStale={isStale}
          onRegenerate={onGenerate}
          regenerating={generating}
          pending={hasPendingSave}
        />
      )}

      {generating && docs.length === 0 && (
        <GeneratingOverlay
          title="Generating Vouchers"
          subtitle="Building flight, hotel & transfer vouchers from booking data…"
          accent="#2563eb"
        />
      )}

      {!generating && docs.length === 0 && (
        <EmptyState
          Icon={Plane}
          title="No vouchers yet"
          hint={'Click "Generate Vouchers" to build flight, hotel and transfer vouchers from this booking’s products.'}
        />
      )}

      {docs.length > 0 && (
        <div className={s.list}>
          {docs.map((doc, i) => (
            <DocRow
              key={doc.id}
              doc={doc}
              index={i}
              isNew={newDocIds.has(doc.id)}
              onDownload={onDownload}
              onView={onView}
              onSend={onSend}
              downloading={downloading}
              regenerating={generating}
            />
          ))}
          {hasPendingSave && <SavingBanner />}
        </div>
      )}
    </div>
  );
};

export default VouchersPanel;
